import React from 'react';
import api from '../../services/api';
import { useStoreState, useStoreActions } from 'easy-peasy';
import {
  Container,
  Popover,
  FormControl,
  Typography,
  Autocomplete as MUIAutocomplete,
  TextField
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Datas from '../../components/Datas';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

const Preenchimento = () => {
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);
  let temaSelecionado = useStoreState(state => state.tema.currTema);
  let setTemaSelecionado = useStoreActions(actions => actions.tema.setTema);

  const [anchorEl, setAnchorEl] = React.useState(false);
  const [temas, setTemas] = React.useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    if (location.pathname == '/preenchimento' && temaSelecionado)
      navigate(temaSelecionado.id);
    else loadTemas(mount);
    return () => {
      mount.isMounted = false;
    };
  }, []);

  React.useEffect(() => {
    if (
      temas &&
      temas.length > 0 &&
      !temaSelecionado &&
      location.pathname != '/preenchimento'
    ) {
      const novoTema = temas.find(
        tema => tema.id == location.pathname.split('/')[2]
      );
      if (novoTema) setTemaSelecionado(novoTema);
    }
  }, [temas]);

  const loadTemas = async mount => {
    startLoading();
    try {
      let data = (await api.http.get('/temas')).data;
      const filteredData = data.filter((tema) => !['13'].includes(tema.id));
      if (mount.isMounted) {
        setTemas(filteredData);
      }
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      throw error;
    }
  };

  const onChangeTema = (newValue, event) => {
    setTemaSelecionado(newValue);
    if (newValue) navigate(newValue.id);
    else navigate('../');
  };

  return (
    <Container
      sx={{
        px: 4,
        pt: 2,
        mt: 3,
        textAlign: 'center'
      }}
    >
      <FormControl>
        <MUIAutocomplete
          sx={{ minWidth: 510 }}
          id="temas"
          options={temas}
          getOptionLabel={tema => tema.id + ' - ' + tema.name}
          renderInput={params => (
            <TextField {...params} label="Selecione o tema" />
          )}
          onChange={(event, newValue) => {
            onChangeTema(newValue);
          }}
          value={temaSelecionado}
          isOptionEqualToValue={(option, value) => option.id == value.id}
        />
      </FormControl>
      <InfoOutlinedIcon
        onClick={handleClick}
        sx={{
          m: 2
        }}
      />
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Typography sx={{ p: 2 }}>
          Este não é seu tema e você não consegue alterar? <br /> Então entre em
          contato com o gestor da sua empresa. <br /> Ele conseguirá alocá-lo
          corretamente em seu grupo de trabalho.
        </Typography>
      </Popover>
      <Outlet />
    </Container>
  );
};

export default Preenchimento;
